import React from "react";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";
import {
  Button,
  Card,
  Modal
} from "@gpstrackit/gtc-react-controls";
import { CarouselComp as Carousel } from 'Modules/.common/components/Corousel';

export const DeleteCollection = ({
  openModalDelete,
  setOpenModalDelete,
  selected,
  setSelected,
  deleteDriverCollection
}) => {
  const { messages } = useIntl();

  return (
    <Modal
      closeButton
      open={openModalDelete}
      footer={
        <div>
          <Button
            onClick={() => {
              setSelected([]);
              setOpenModalDelete(false);
            }}
            style={{ marginRight: 8 }}
            variant="secondary"
          >
            close
          </Button>
          <Button
            onClick={() => {
              setOpenModalDelete(false);
              deleteDriverCollection();
            }}
            variant="warning"
          >
            {messages["delete"]}
          </Button>
        </div>
      }
      handleClose={() => {
        setSelected([]);
        setOpenModalDelete(false);
      }}
      position="right"
      size="small"
      title={messages["settingsDriver_driversFacesDeleteCollectionTitle"]}
    >
      <Box display="flex" flexDirection="column" padding="15px">
        <div
          style={{
            position: "absolute",
            zIndex: "1",
            background: "white",
            marginTop: "-15px",
            paddingTop: "15px",
            marginBottom: "5px",
            width: "100%",
          }}
        >
          <p>{messages["settingsDriver_driversFacesdeleteCollection"]}</p>
        </div>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginTop="75px"
        >
          {selected.map((item) => {
            return (
              <div style={{ marginBottom: "10px", zIndex: 0 }}>
                <Card heigth="300px">
                  <Carousel item={item} expandImage />
                </Card>
              </div>
            );
          })}
        </Box>
      </Box>
    </Modal>
  );
};
